import { apiWrapper } from '../helper/api-wrapper';

export const getNotification = async (actorType, offset) => {
  try {
    const response = await apiWrapper.get(
      `merchants/dashboard/notification?actor_type=${actorType}&offset=${offset}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getNotificationTop = async (actorType) => {
  try {
    const response = await apiWrapper.get(
      `merchants/notification/top?actor_type=${actorType}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateNotification = async (id) => {
  try {
    const response = await apiWrapper.get(
      `merchants/dashboard/notification/${id}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const readAllNotification = async () => {
  try {
    const response = await apiWrapper.get('merchants/notification/read_all');

    return response;
  } catch (error) {
    throw error;
  }
};
